var map = {
	"./": 56357,
	"./about_us": 13620,
	"./about_us/": 13620,
	"./about_us/index": 13620,
	"./about_us/index.jsx": 13620,
	"./apply": 74475,
	"./apply/": 74475,
	"./apply/index": 74475,
	"./apply/index.jsx": 74475,
	"./apply/style.css": 81684,
	"./careers": 34791,
	"./careers/": 34791,
	"./careers/careers_detail": 69527,
	"./careers/careers_detail/": 69527,
	"./careers/careers_detail/index": 69527,
	"./careers/careers_detail/index.jsx": 69527,
	"./careers/index": 34791,
	"./careers/index.jsx": 34791,
	"./contacts": 92563,
	"./contacts/": 92563,
	"./contacts/index": 92563,
	"./contacts/index.jsx": 92563,
	"./home/Banner": 92638,
	"./home/Banner/": 92638,
	"./home/Banner/index": 92638,
	"./home/Banner/index.jsx": 92638,
	"./home/news_releases": 13443,
	"./home/news_releases/": 13443,
	"./home/news_releases/index": 13443,
	"./home/news_releases/index.jsx": 13443,
	"./home/our_partners": 72638,
	"./home/our_partners/": 72638,
	"./home/our_partners/index": 72638,
	"./home/our_partners/index.jsx": 72638,
	"./home/our_portfolio": 11996,
	"./home/our_portfolio/": 11996,
	"./home/our_portfolio/index": 11996,
	"./home/our_portfolio/index.jsx": 11996,
	"./home/our_solution": 97107,
	"./home/our_solution/": 97107,
	"./home/our_solution/index": 97107,
	"./home/our_solution/index.jsx": 97107,
	"./index": 56357,
	"./index.jsx": 56357,
	"./news": 99788,
	"./news/": 99788,
	"./news/index": 99788,
	"./news/index.jsx": 99788,
	"./news/news_detail": 68743,
	"./news/news_detail/": 68743,
	"./news/news_detail/index": 68743,
	"./news/news_detail/index.jsx": 68743,
	"./products": 40464,
	"./products/": 40464,
	"./products/crm": 97946,
	"./products/crm/": 97946,
	"./products/crm/index": 97946,
	"./products/crm/index.jsx": 97946,
	"./products/fms": 26352,
	"./products/fms/": 26352,
	"./products/fms/index": 26352,
	"./products/fms/index.jsx": 26352,
	"./products/hrm": 90499,
	"./products/hrm/": 90499,
	"./products/hrm/index": 90499,
	"./products/hrm/index.jsx": 90499,
	"./products/index": 40464,
	"./products/index.jsx": 40464,
	"./products/lms": 90307,
	"./products/lms/": 90307,
	"./products/lms/index": 90307,
	"./products/lms/index.jsx": 90307,
	"./products/sns": 63426,
	"./products/sns/": 63426,
	"./products/sns/index": 63426,
	"./products/sns/index.jsx": 63426,
	"./solutions": 23448,
	"./solutions/": 23448,
	"./solutions/bigdata": 32191,
	"./solutions/bigdata/": 32191,
	"./solutions/bigdata/index": 32191,
	"./solutions/bigdata/index.jsx": 32191,
	"./solutions/blockchain": 29909,
	"./solutions/blockchain/": 29909,
	"./solutions/blockchain/index": 29909,
	"./solutions/blockchain/index.jsx": 29909,
	"./solutions/index": 23448,
	"./solutions/index.jsx": 23448,
	"./solutions/iots": 66356,
	"./solutions/iots/": 66356,
	"./solutions/iots/index": 66356,
	"./solutions/iots/index.jsx": 66356,
	"./solutions/our_sourcing": 54085,
	"./solutions/our_sourcing/": 54085,
	"./solutions/our_sourcing/index": 54085,
	"./solutions/our_sourcing/index.jsx": 54085,
	"./solutions/twells": 784,
	"./solutions/twells/": 784,
	"./solutions/twells/index": 784,
	"./solutions/twells/index.jsx": 784
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38399;